import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "calculate" }
const _hoisted_2 = { class: "calculate-basic" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slider = _resolveComponent("slider")!
  const _component_sollzinsbindung = _resolveComponent("sollzinsbindung")!
  const _component_sondertilgung = _resolveComponent("sondertilgung")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_slider, {
        id: "kaufpreis",
        labelText: _ctx.textSliderKaufpreis,
        "slider-values": _ctx.sliderPreis,
        "slider-to-input-conversion": 1000,
        "tooltip-text": _ctx.textToolTipKaufpreis,
        unit: ".000 €",
        onValueChanged: _ctx.onKaufpreisChanged,
        onSlide: _ctx.onSlideKaufpreis,
        onValueOutOfRange: _ctx.onKaufpreisOutOfRange
      }, null, 8, ["labelText", "slider-values", "tooltip-text", "onValueChanged", "onSlide", "onValueOutOfRange"]),
      _createVNode(_component_slider, {
        id: "darlehen",
        labelText: _ctx.textSliderDarlehen,
        "slider-values": _ctx.sliderDarlehen,
        "slider-to-input-conversion": 1000,
        "tooltip-text": _ctx.textToolTipDarlehen,
        unit: ".000 €",
        fakeslider: true,
        "width-fake-slider": _ctx.widthFakeSlider,
        onValueChanged: _ctx.onDarlehenChanged,
        onValueOutOfRange: _ctx.onDarlehenOutOfRange
      }, null, 8, ["labelText", "slider-values", "tooltip-text", "width-fake-slider", "onValueChanged", "onValueOutOfRange"]),
      _createVNode(_component_sollzinsbindung, {
        onSollzinsbindungChanged: _ctx.onSollzinsbindungChanged,
        onVolltilgungChanged: _ctx.onVolltilgungChanged
      }, null, 8, ["onSollzinsbindungChanged", "onVolltilgungChanged"])
    ]),
    _createVNode(_component_sondertilgung)
  ]))
}